import { ContextMenu } from "./ContextMenu";
import { ContextMenuCreator } from "./ContextMenuCreator";

export class ContextMenuLibrary
{
  protected _menus:ContextMenuCreator[] = [];

  protected _set( ...creators:ContextMenuCreator[] )
  {
    this._menus.splice( this._menus.length -1, 0, ...creators );
  }

  protected _setAll( creators:ContextMenuCreator[] )
  {
    this._menus = creators;
  }

  create( e:Element ):ContextMenu
  {
    let creator = this._menus.find( m => m.value.in( e ) );
    
    if ( ! creator )
    {
      return null;
    }

    return creator.create( e );
  }
}